export default __webpack_public_path__ + "static/media/visaelectron.8174f55f.svg";